import { http } from "@client/shared/services";
import { responseFormatter } from "@client/utils";

const get = (query = "") => {
  return responseFormatter(
    http.get(`/rc-account/role${query}`, {
      setAuthHeader: true
    })
  );
};

const patch = (id = "", payload) => {
  return responseFormatter(
    http.patch(`/rc-account/role/${id}`, payload, {
      setAuthHeader: true
    })
  );
};

const UserService = {
  get,
  patch,
};

export default UserService;